module.exports = __webpack_public_path__ + "img/ebcZhW.17bd242a.svg";